import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyText]'
})
export class OnlyTextDirective {

  private regex: RegExp;

  constructor(private readonly el: ElementRef) { }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    this.validate(event, event.key === 'Enter' ? '\n' : event.key);
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pastedText = event.clipboardData?.getData('text/plain') || '';
    this.validate(event, pastedText);
  }

  @HostListener('cut', ['$event'])
  onCut(event: Event) {
    this.validate(event, '');
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    this.cleanInvalidChars();
  }

  private validate(event: Event, text: string) {
    const textoInput = this.el.nativeElement;
    const novoValor = (textoInput.value.substring(0, textoInput.selectionStart)
      + text
      + textoInput.value.substring(textoInput.selectionEnd));

    if (!this.regex) {
      this.regex = /^[A-Za-zÀ-ÿ\s]*$/g;
    }

    if (!novoValor.match(this.regex)) {
      event.preventDefault();
    }
  }

  private cleanInvalidChars() {
    const input = this.el.nativeElement;
    let value = input.value;

    value = value.replace(/[^A-Za-zÀ-ÿ\s]/g, '');
    input.value = value;
  }
}
